/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
const PageNotFound: React.FC = (props) => {
    return <h1>Access is Denied</h1>;
};

export default PageNotFound;
